import React, {ReactNode} from 'react';
import {Box, Typography} from "@mui/material"

interface StatBlockProps {
    value: ReactNode
    label: string
}

function StatBlock({value, label}: StatBlockProps) {
    return (
        <Box>
            <Typography component="div" sx={{fontSize: "1.125rem", fontWeight: 600, lineHeight: 1.3}}>{value}</Typography>
            <Typography component="div" variant="caption" color="text.secondary">{label}</Typography>
        </Box>
    )
}

export default StatBlock;
